import echarts from 'echarts'
import 'echarts/theme/dark.js'
import 'echarts/theme/roma.js'
import 'echarts/theme/shine.js'
import 'echarts/theme/vintage.js'
import 'echarts/theme/macarons.js'
import 'echarts/theme/infographic.js'
let darkPro = require('@/plugin/echarts/theme/dark-pro.json')
echarts.registerTheme('darkPro', darkPro)
export default echarts
